import { useData } from "../data/DataContext";
import { ContentHeader } from "../components/ContentHeader";
import { OPERATIONS } from "../nav";

export function ToolsTab() {
  const { links } = useData();
  const meta = OPERATIONS.find((e) => e.id === "tools")!;
  if (!links) return <div className="empty">No legacy links.json found.</div>;

  const cats = [...links.categories].sort((a, b) => a.order - b.order);
  return (
    <>
      <ContentHeader title={meta.label} count={links.links.length} description={meta.desc} />
      {cats.map((cat) => {
        const items = links.links.filter((l) => l.category === cat.id);
        if (items.length === 0) return null;
        return (
          <section key={cat.id}>
            <div className="section-header">
              <h2>{cat.icon} {cat.name}</h2>
              <span className="count">{items.length}</span>
            </div>
            <div className="grid">
              {items.map((l) => (
                <div key={l.id} className="card" style={{ cursor: "default" }}>
                  <div className="card-name">{l.name}</div>
                  {l.description && (
                    <div className="card-meta" style={{ color: "var(--text-muted)" }}>{l.description}</div>
                  )}
                  {l.envs && l.envs.length > 0 && (
                    <div className="env-badges">
                      {l.envs.map((e) => (
                        <a key={e.url} className={`env-badge ${e.label}`}
                           href={e.url} target="_blank" rel="noopener noreferrer"
                           title={e.url}>{e.label}</a>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </section>
        );
      })}
    </>
  );
}
